<ng-container *ngIf="loyaltyCurrencySelected$ | async as loyaltyCurrency">
  <rd-tcv2-programs-banner-wrapper [loyaltyCurrencySelected]="loyaltyCurrency">
  </rd-tcv2-programs-banner-wrapper>
</ng-container>

<div class="container">
  <div
    class="loyalty-program-filters mb-4 lg:mb-8"
    *ngIf="transferConnectV2SettingService.showListingFilters">
    <rd-tcv2-loyalty-programs-category-filter
      [category]="loyaltyProgramCategory"
      [categoryOptions]="loyaltyProgramCategoryOptions"
      (categoryChange)="categoryChange($event)"
      *ngIf="transferConnectV2SettingService.showCategoryFilter">
    </rd-tcv2-loyalty-programs-category-filter>
    <rd-shared-keyword-filter
      [keyword]="keyword"
      [keywordPlaceholder]="'transfer.programs.keyword_placeholder' | translate"
      (keywordChange)="keywordChange($event)">
    </rd-shared-keyword-filter>
  </div>

  <div *ngIf="transferConnectV2SettingService.shouldRenderListingAlert">
    <rd-shared-alert class="mb-7 lg:mb-8" [icon]="'info'">
      <span
        class="alert-text typo-small-text-mobile lg:typo-text-desktop"
        [innerHTML]="'transfer_v2.programs.alert' | translate"></span>
    </rd-shared-alert>
  </div>

  <ng-container *ngIf="vm$ | async as vm">
    <rd-tcv2-loyalty-programs-list
      [loading]="vm.loading"
      [error]="vm.error"
      [loyaltyPrograms]="vm.loyaltyPrograms"
      [loyaltyCurrencySelected]="vm.selectedLoyaltyCurrency">
    </rd-tcv2-loyalty-programs-list>
  </ng-container>
</div>
